import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const RightDashboardLoader = () => {
	return (
		<StyledRightDashboardLoader>
			<section className="mainResponsiveWrapper">
				<Profile>
					<div className="motif-row">
						<div className="motif-col-lg-2 tab-item">
							<Skeleton height={40} />
						</div>
						<div className="motif-col-lg-2 tab-item">
							<Skeleton height={40} />
						</div>
						<div className="motif-col-lg-2 tab-item">
							<Skeleton height={40} />
						</div>
						<div className="motif-col-lg-2 tab-item">
							<Skeleton height={40} />
						</div>
						<div className="motif-col-lg-2 tab-item">
							<Skeleton height={40} />
						</div>
					</div>
				</Profile>
				{/* <Profile><Skeleton circle={false} height={40} count={5} /> </Profile>*/}
				<SkeletonWrapper>
					<Skeleton circle={false} height={40} width={200} />
					<Skeleton circle={false} count={6} height={20} />
				</SkeletonWrapper>
				<FlexWrapper>
					<section className="flexHeightWrpper">
						<SkeletonWrapper>
							<div className="skeletonFlexContainer">
								<div className="skeletonFlexColumnContainer">
									<Skeleton circle={false} height={30} width={200} />
									<Skeleton circle height={180} width={180} />
								</div>
								<div className="skeletonFlexColumnContainer">
									<Skeleton circle={false} height={30} width={200} />
									<div className="skeletonMargin">
										<Skeleton circle={false} count={4} height={20} width={212} />
									</div>
								</div>
							</div>
						</SkeletonWrapper>
					</section>
					<section className="flexHeightWrpper">
						<SkeletonWrapper>
							<Skeleton circle={false} height={30} width={200} />
							<Skeleton circle={false} count={5} height={20} />
						</SkeletonWrapper>
					</section>
				</FlexWrapper>
				<SkeletonWrapper>
					<div className="skeletonAccordion skeletonFlexContainer">
						<Skeleton circle={false} height={40} width={200} count={2} />
					</div>
					<Skeleton circle={false} count={8} height={20} />
				</SkeletonWrapper>
			</section>
		</StyledRightDashboardLoader>
	);
};

export default RightDashboardLoader;

const StyledRightDashboardLoader = styled.section`
	overflow: hidden;
	padding-left: var(--content-h-pad);
	padding-right: var(--content-h-pad);
	.mainResponsiveWrapper {
		max-width: 100%;
		display: flex;
		flex-direction: column;
		gap: var(--content-v-pad);
	}
`;
const Profile = styled.section`
	background: ${(props) => props.theme.color[`white`]};
	padding-bottom: 0.8rem;
	padding-left: 1.2rem;
	border: 0.1rem solid ${(props) => props.theme.color[`grey300`]};
	margin-top: var(--content-v-pad);
	.tab-item {
		margin-left: 2rem;
		padding: 0;
		span {
			height: 25px;
		}
	}
	.react-loading-skeleton {
		background-color: ${(props) => props.theme.color[`grey250`]};
		background-image: linear-gradient(
			90deg,
			${(props) => props.theme.color[`grey250`]},
			${(props) => props.theme.color[`grey100`]},
			${(props) => props.theme.color[`grey250`]}
		);
	}
`;

const SkeletonWrapper = styled.section`
	background: ${(props) => props.theme.color[`white`]};
	padding: 2rem 2rem 4rem;
	border: 0.1rem solid ${(props) => props.theme.color[`grey300`]};
	display: flex;
	flex-direction: column;
	margin-top: 2rem;
	.react-loading-skeleton {
		margin-top: 2rem;
		background-color: ${(props) => props.theme.color[`grey250`]};
		background-image: linear-gradient(
			90deg,
			${(props) => props.theme.color[`grey250`]},
			${(props) => props.theme.color[`grey100`]},
			${(props) => props.theme.color[`grey250`]}
		);
	}
	.skeletonFlexContainer {
		display: flex;
		width: 100%;
		padding: 0 3rem;
		&.skeletonAccordion {
			justify-content: space-between;
		}
		.skeletonFlexColumnContainer {
			display: flex;
			flex-direction: column;
			width: 100%;
			.skeletonMargin {
				margin-top: 4rem;
			}
		}
	}
`;

const FlexWrapper = styled.section`
	-webkit-box-pack: justify;
	justify-content: space-between;
	display: flex;
	margin: 0;
	.flexHeightWrpper {
		width: calc(50% - 1rem);
	}
`;
